import { useSelector, shallowEqual } from "react-redux";
import BookingInformation from "app/pages/.shared/BookingInformation/BookingInformation";

const mapStateToProps = state => {
	const offerType = state.booking?.offer?.type;
	const ficheProduit = state.ficheProduit;
	return {
		dvaf: state.documents.dvaf[offerType] ? state.documents.dvaf[offerType] : undefined,
		usefulInformations: ficheProduit.usefulInformations,
		contractRemarks: state.payment.contractRemarks,
	};
};

const BookingInformationContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <BookingInformation {...props} {...stateProps} />;
};

export default BookingInformationContainer;
